import { Component } from '@angular/core';
import { UniTextComponent } from '../uni-text/uni-text.component';

@Component({
  selector: 'uni-text-header',
  templateUrl: './uni-text-header.component.html',
  styleUrls: ['./uni-text-header.component.scss'],
})
export class UniTextHeaderComponent extends UniTextComponent {}
